// @ts-nocheck
export const reduceStr = (str) => {
  return str ? `${str.substring(0,5)}…${str.slice(-5)}` : null;
}